module.exports = __webpack_public_path__ + "static/media/people01.5e2a3caa.png";